import { DATA_TEST_ID_ATTRIBUTE_NAME } from './constants';

export const buildDataTestId = (prefix?: any | string, name?: string) => {
  return prefix ? `${prefix}_${name}` : undefined;
};

export const buildFullDataTestId = (section: string, fileOrElementName: string, elementName?: string) => {
  const elementNameWithUnderscore = elementName ? `_${elementName}` : '';
  return `${section}__${fileOrElementName}${elementNameWithUnderscore}`;
};

export const buildDataTestIdAttribute = (prefix?: any | string, name?: string) => ({
  [DATA_TEST_ID_ATTRIBUTE_NAME]: name ? buildDataTestId(prefix, name) : prefix,
});

export function capitalizeOnlyFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
